import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CardQuick from '../../components/Card';
import { useNavigate } from "react-router-dom";
import { dashboardService } from "../../services";


const CurrentAccountCard = ({locationId}) => {
    const navigate = useNavigate();
    const [data,setData]=useState({});
    useState(()=>{
        dashboardService.getCurrentAccountStats(locationId).then((data)=>{
            setData(data);
        }).catch(()=>{

        })
    },[locationId])
    return (
        <Box >
            <CardQuick>
                <Typography variant="h2">Saldo à Receber</Typography>
                <Typography variant="h1" color='green'>{data?.balance||'N/A'}</Typography>
                <Box mb={4} />
                <Typography variant="h4">Ultimo Recebimento</Typography>
                <Typography variant="h2" >{data?.last_payout_amount || 'N/A'}</Typography>
                <Typography variant="body1">{data?.last_payout_date || 'N/A'}</Typography>
            </CardQuick>
            <Box sx={{borderBottomLeftRadius:4,borderBottomRightRadius:4}} bgcolor={'#ececec'}>
            <Button onClick={()=>{
                navigate('current-account');
            }} sx={{margin:'8px'}} variant="contained" color="secondary2">Ver conta corrente</Button>

            </Box>
        </Box>

    )

}

export default CurrentAccountCard;